import firestore from "../firebase.config";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
    Box,
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Grid,
    Divider,
    Typography,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";
import { useAuth } from "../context/AuthContext";
import Footer from "./Components/footer";
import "../App.css";
import { StayPrimaryLandscape } from "@material-ui/icons";

// fetch all videos
const fetchVideos = async () => {
    const data = await firestore.collection("videos").get();
    return data.docs.map((doc) => doc.data());
};


// fetch pop videos
// const fetchPopVideos = async () => {
//     const popVideoList = await firestore.collection("popular_videos").get();
//     const popIds = popVideoList.docs.map((doc) => doc.data().videoId);

//     const popVideos = await firestore
//         .collection("videos")
//         .where("videoId", "in", popIds)
//         .get();

//     return popVideos.docs.map((doc) => doc.data());
// };

// top 8 trending
const fetchTrendingVideos = async () => {
    const topViewList = await firestore
        .collection("videos")
        .orderBy("view", "desc")
        .limit(8)
        .get();
    const topIds = topViewList.docs.map((doc) => doc.data());

    // console.log(topIds);
    return topIds;
};

// filter videos
const filterVideos = (filter, allVideos) => {
    if (filter == null || filter.length === 0) {
        return allVideos;
    }

    const filteredVideos = allVideos.filter(function (vid) {
        return filter.some(function (fil) {
            return vid.category === fil;
        });
    });

    return filteredVideos;
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    filterbar: {
        margin: theme.spacing(2),
    },
    cardhover: {
        backgroundColor: "rgba(170, 30, 60, 0.9)",
        color: "#ffffff",

        "&:hover": {
            background: "rgba(170, 30, 60, 0.5)",
            color: "#000000",
        },
    },
    videocard: {
        transition: "transform 250ms",
        "&:hover": {
            transform: "scale(1.1)",
        },
    },
}));

function Browse() {
    const [videos, setVideos] = useState([]);
    // const [popVideos, setPopVideos] = useState([]);
    const [topVideos, setTopVideos] = useState([]);
    const [filteredVideos, setFilteredVideos] = useState();
    const [filter, setFilter] = useState();
    const { currentUser } = useAuth();
    const classes = useStyles();

    const handleFilter = (evt, val) => {
        setFilter(val);
    };

    useEffect(() => {
        fetchVideos().then((allVideos) => {
            setVideos(allVideos);
            setFilteredVideos(allVideos);
        });

        // fetchPopVideos().then((popVideos) => {
        //     setPopVideos(popVideos);
        // });

        fetchTrendingVideos().then((topIds) => {
            setTopVideos(topIds);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setFilteredVideos(filterVideos(filter, videos));
    }, [filter, videos]);

    return (
        <div>
            <div className="wrapper">

                {topVideos && (
                    <div className="category">
                        <Typography
                            variant="h4"
                            style={{ marginBottom: 20, textAlign: "left" }}
                        >
                            Trending &micro;Lesson
                        </Typography>
                        <Grid container spacing={3}>
                            {topVideos.map((vid, i) => {
                                return (
                                    <Grid item xs={3}>
                                        <Link
                                            key={i}
                                            to={`/playVideo/${vid.videoId}`}
                                            style={{ textDecoration: "none" }}
                                        >
                                            <Card className={classes.videocard}>
                                                <CardActionArea>
                                                    <CardMedia
                                                        component="img"
                                                        height="150"
                                                        width="150"
                                                        image={`https://img.youtube.com/vi/${vid.videoId}/default.jpg`}
                                                        title={vid.title}
                                                        alt={vid.title}
                                                    />
                                                </CardActionArea>
                                                <CardContent>
                                                    <Typography noWrap>
                                                        {" "}
                                                        {vid.title}{" "}
                                                    </Typography>
                                                </CardContent>
                                                <Box
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                    mr={2}
                                                >
                                                    <Box
                                                        bgcolor="text.primary"
                                                        color="background.paper"
                                                        mb={1}
                                                        borderRadius={16}
                                                        width="50%"
                                                        height="10%"
                                                    >
                                                        <Typography
                                                            noWrap
                                                            style={{
                                                                fontSize: 12,
                                                            }}
                                                        >
                                                            {vid.category}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Card>
                                        </Link>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </div>
                )}

                <Divider style={{ height: 3 }} />

                {filteredVideos && (
                    <div className="category">
                        <Typography
                            variant="h4"
                            style={{ marginBottom: 20, textAlign: "left" }}
                        >
                            All &micro;Lessons
                        </Typography>
                        <div className={classes.filterbar}>
                            <Typography variant="subtitle1">
                                Select the categories to filter &micro;Lessons
                            </Typography>
                            <ToggleButtonGroup
                                value={filter}
                                onChange={handleFilter}
                                color="primary"
                            >
                                <ToggleButton value="machine learning">
                                    Machine Learning
                                </ToggleButton>
                                <ToggleButton value="data science">
                                    Data Science
                                </ToggleButton>
                                <ToggleButton value="neural network">
                                    Neural Network
                                </ToggleButton>
                                <ToggleButton value="evolutionary algorithm">
                                    Evolutionary Algorithm
                                </ToggleButton>
                                <ToggleButton value="nlp">NLP</ToggleButton>
                                <ToggleButton value="computer vision">
                                    Computer Vision
                                </ToggleButton>
                                <ToggleButton value="python">
                                    Python
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <Grid container spacing={3}>
                            {filteredVideos.map((vid, i) => {
                                return (
                                    <Grid item xs={3}>
                                        <Link
                                            key={i}
                                            to={`/playVideo/${vid.videoId}`}
                                            style={{ textDecoration: "none" }}
                                        >
                                            <Card className={classes.videocard}>
                                                <CardActionArea>
                                                    <CardMedia
                                                        component="img"
                                                        height="150"
                                                        width="150"
                                                        image={`https://img.youtube.com/vi/${vid.videoId}/default.jpg`}
                                                        title={vid.title}
                                                        alt={vid.title}
                                                    />
                                                </CardActionArea>
                                                <CardContent>
                                                    <Typography noWrap>
                                                        {" "}
                                                        {vid.title}{" "}
                                                    </Typography>
                                                </CardContent>
                                                <Box
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                    mr={2}
                                                >
                                                    <Box
                                                        bgcolor="text.primary"
                                                        color="background.paper"
                                                        mb={1}
                                                        borderRadius={16}
                                                        width="50%"
                                                        height="10%"
                                                    >
                                                        <Typography
                                                            noWrap
                                                            style={{
                                                                fontSize: 12,
                                                            }}
                                                        >
                                                            {vid.category}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Card>
                                        </Link>
                                    </Grid>
                                );
                            })}
                            <Grid
                                item
                                xs={3}
                                container
                                spacing={0}
                                align="center"
                                justify="center"
                                direction="column"
                            >
                                <Link
                                    to="/search-category"
                                    style={{
                                        textDecoration: "none",
                                        height: "100%",
                                    }}
                                >
                                    <Card
                                        style={{ height: "100%" }}
                                        className={classes.cardhover}
                                    >
                                        <Box component="div" mt={8}>
                                            <SearchIcon />
                                            <Typography>
                                                Search more by category
                                            </Typography>
                                        </Box>
                                    </Card>
                                </Link>
                            </Grid>
                        </Grid>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
}

export default Browse;
